import { object, string } from 'yup'

export const forgetSchema = object({
    email: string().email("Informe um e-mail válido").required("E-mail é obrigatório"),
})